export default {

    businessDashboard : [
        { path: "messenger" , component:() => import("@/modules/messenger/components/DashMessenger")               , props : true },
    ]
}


